import React, { useState } from "react";
import {
    Card,
    Typography,
    Button,
    Select,
    Upload,
    message,
    Table,
    Space,
    Row,
    Col,
} from "antd";
import { UploadOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import TabsComp from "../../tabs/Tabs";

const { Title, Text } = Typography;
const { Option } = Select;

const TataCapitalUploadDocs = () => {
    const [documentType, setDocumentType] = useState("");
    const [documentSubType, setDocumentSubType] = useState("");
    const [fileList, setFileList] = useState([]);
    const [addedDocuments, setAddedDocuments] = useState([]);

    // Document Type Options (From your first image)
    const documentTypes = [
        "Aadhaar",
        "Pan Card",
        "Address Proof",
        "Bank Statements",
        "ITR",
        "Form 26AS",
        "Income Proof",
        "Signature Mismatch Declaration",
        "Additional Documents",
        // Add more as needed...
    ];

    // Document Sub Type Options (From your second image)
    const documentSubTypes = [
        "Passport",
        "Driving License",
        "Voter ID",
        "Electricity Bill",
        "Telephone Bill",
        "Rent Agreement",
        "Bank Passbook",
        "Salary Slip - 3 months",
        "Form 16",
        "Cancelled Cheque",
        "Others",
        // Add more as needed...
    ];

    const handleAddDocument = () => {
        if (!documentType) {
            message.error("Please select Document Type");
            return;
        }
        if (!documentSubType) {
            message.error("Please select Document Sub Type");
            return;
        }
        if (fileList.length === 0) {
            message.error("Please upload a file");
            return;
        }

        const newDoc = {
            key: Date.now(),
            documentType,
            documentSubType,
            fileName: fileList[0].name,
            file: fileList[0],
        };

        setAddedDocuments([...addedDocuments, newDoc]);
        setFileList([]);
        setDocumentType("");
        setDocumentSubType("");

        message.success("Document added successfully!");
    };

    const handleRemove = (key) => {
        setAddedDocuments(addedDocuments.filter((doc) => doc.key !== key));
        message.info("Document removed");
    };

    const columns = [
        {
            title: "Document Type",
            dataIndex: "documentType",
            key: "documentType",
        },
        {
            title: "Sub Type",
            dataIndex: "documentSubType",
            key: "documentSubType",
        },
        {
            title: "File Name",
            dataIndex: "fileName",
            key: "fileName",
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleRemove(record.key)}
                >
                    Remove
                </Button>
            ),
        },
    ];

    return (
        <>
            <TabsComp header="Tata Capital Document Verification" showBreadCrum={true} />

            <div style={{ padding: "20px 24px", background: "#f9fafb" }}>
                <Card
                    bordered={false}
                    style={{
                        borderRadius: 16,
                        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                    }}
                    bodyStyle={{ padding: 24 }}
                >
                    {/* Header */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 24,
                            borderBottom: "1px solid #f0f0f0",
                            paddingBottom: 16,
                        }}
                    >
                        <div>
                            <Title level={4} style={{ margin: 0 }}>
                                Upload Documents
                            </Title>
                            <Text type="secondary">
                                Upload required applicant documents
                            </Text>
                        </div>

                   
                    </div>

                    <Row gutter={[20, 20]} align="bottom">
                        {/* Document Type */}
                        <Col xs={24} sm={24} md={8}>
                            <div style={{ marginBottom: 8, fontWeight: 500 }}>
                                Document Type
                            </div>

                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select Document Type"
                                value={documentType}
                                onChange={setDocumentType}
                                size="large"
                            >
                                {documentTypes.map((type) => (
                                    <Option key={type} value={type}>
                                        {type}
                                    </Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Document Sub Type */}
                        <Col xs={24} sm={24} md={8}>
                            <div style={{ marginBottom: 8, fontWeight: 500 }}>
                                Document Sub Type
                            </div>

                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select Document Sub Type"
                                value={documentSubType}
                                onChange={setDocumentSubType}
                                size="large"
                            >
                                {documentSubTypes.map((sub) => (
                                    <Option key={sub} value={sub}>
                                        {sub}
                                    </Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Upload File */}
                        <Col xs={24} sm={24} md={5}>
                            <div style={{ marginBottom: 8, fontWeight: 500 }}>
                                Upload File
                            </div>

                            <Upload
                                beforeUpload={(file) => {
                                    setFileList([file]);
                                    return false;
                                }}
                                fileList={fileList}
                                maxCount={1}
                                onRemove={() => setFileList([])}
                            >
                                <Button
                                    icon={<UploadOutlined />}
                                    size="large"
                                    style={{
                                        width: "100%",
                                        height: 44,
                                        borderRadius: 10,
                                    }}
                                >
                                    Select File
                                </Button>
                            </Upload>
                        </Col>

                        {/* Add Button */}
                        <Col xs={24} sm={24} md={3}>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                size="large"
                                onClick={handleAddDocument}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    fontWeight: 600,
                                }}
                            >
                                Add
                            </Button>
                        </Col>
                    </Row>
                </Card>

                {/* Added Documents List */}
                {addedDocuments.length > 0 && (
                    <Card title="Added Documents" style={{ marginTop: 24 }}>
                        <Table
                            columns={columns}
                            dataSource={addedDocuments}
                            pagination={false}
                            bordered
                        />
                    </Card>
                )}

                {addedDocuments.length > 0 && (
                    <div style={{ textAlign: "center", marginTop: 20 }}>
                        <Button type="primary" size="large">
                            Submit All Documents
                        </Button>
                    </div>
                )}
            </div>
        </>
    );
};

export default TataCapitalUploadDocs;